<!-- Responsibility: Implement sys section account behavior for the ui/panels surface.
Scope: Owns ui/panels concerns only; cross-surface orchestration is excluded. -->
<sys-section-account>
  <div class="sys-section-account">
    <p if={ props.view?.isGuest && !props.view?.devOnly } class="account-note guest">
      GUEST MODE — saves are local only
    </p>
    <p if={ !props.view?.isGuest && props.view?.userName && !props.view?.devOnly } class="account-note signed-in">
      Signed in as <b class="account-user-name">{ props.view.userName }</b>
    </p>

    <button if={ !props.view?.devOnly } class="action-btn" style="margin-top:var(--space-lg);margin-bottom:var(--space-lg);color:var(--danger);border-color:var(--danger);" onclick={ () => props.actions?.signOut?.() }>
      SIGN OUT
    </button>

    <h5 if={ !props.view?.devOnly } class="section-title">PERSISTENCE</h5>
    <p if={ !props.view?.devOnly } class="perf-note">
      Mode: <b>{ props.view?.persistMode === 'local-only' ? 'LOCAL ONLY' : 'HYBRID' }</b>.
      Local-only keeps save lifecycle in browser storage; hybrid uses cloud + local fallback queue.
    </p>
    <button
      if={ !props.view?.devOnly }
      class="action-btn"
      style="margin-top:var(--space-xs);"
      disabled={ props.view?.persistBusy || props.view?.persistMode === 'hybrid' }
      onclick={ () => props.actions?.switchPersistenceMode?.('hybrid') }
    >USE HYBRID</button>
    <button
      if={ !props.view?.devOnly }
      class="action-btn"
      style="margin-top:var(--space-xs);"
      disabled={ props.view?.persistBusy || props.view?.persistMode === 'local-only' }
      onclick={ () => props.actions?.switchPersistenceMode?.('local-only') }
    >USE LOCAL ONLY</button>
    <button if={ !props.view?.devOnly } class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.exportActiveBackup?.() } disabled={ props.view?.backupBusy }>
      EXPORT ACTIVE BACKUP
    </button>
    <button if={ !props.view?.devOnly } class="action-btn" style="margin-top:var(--space-xs);" onclick={ openBackupImport } disabled={ props.view?.backupBusy }>
      IMPORT BACKUP
    </button>
    <input ref="backupImportInput" type="file" accept="application/json" hidden onchange={ onBackupImportFile }>
    <p if={ !props.view?.devOnly && props.view?.persistMsg } class="perf-note">{ props.view.persistMsg }</p>
    <p if={ !props.view?.devOnly && props.view?.backupMsg } class="perf-note">{ props.view.backupMsg }</p>

    <div if={ !props.view?.devOnly && props.view?.driveAvailable }>
      <h5 class="section-title" style="margin-top:var(--space-md);">GDRIVE SYNC (OPTIONAL)</h5>
      <p class="perf-note">
        Direct Google Drive adapter for backup sync. Uses your Drive app-data space and keeps browser/cloud save modes unchanged.
      </p>
      <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.connectDriveNow?.() } disabled={ props.view?.driveBusy }>
        { props.view?.driveConnected ? 'RECONNECT GOOGLE DRIVE' : 'CONNECT GOOGLE DRIVE' }
      </button>
      <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.syncActiveBackupToDrive?.() } disabled={ props.view?.driveBusy }>
        SYNC ACTIVE BACKUP TO DRIVE
      </button>
      <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.pullLatestDriveBackup?.() } disabled={ props.view?.driveBusy || !props.view?.driveFiles?.length }>
        IMPORT LATEST DRIVE BACKUP
      </button>
      <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.refreshDriveBackups?.() } disabled={ props.view?.driveBusy }>
        REFRESH DRIVE BACKUPS
      </button>
      <div class="perf-list" if={ props.view?.driveFiles?.length } style="margin-top:0.6rem;">
        <div each={ item in props.view.driveFiles } class="perf-row">
          <span class="perf-job">{ item.name }</span>
          <span class="perf-metrics">{ props.view?.formatTime?.(item.modifiedTime) } · { props.view?.formatBytes?.(item.size || 0) }</span>
          <button class="action-btn" onclick={ () => props.actions?.importDriveBackup?.(item.id) } disabled={ props.view?.driveBusy }>IMPORT</button>
        </div>
      </div>
      <p class="perf-note" if={ props.view?.driveMsg }>{ props.view.driveMsg }</p>
    </div>

    <h5 if={ !props.view?.devOnly } class="section-title">AI CONFIGURATION</h5>
    <div if={ !props.view?.devOnly && props.view?.aiStatus } class="sys-ai-status">{ props.view.aiStatus }</div>
    <button if={ !props.view?.devOnly } class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.openAiSettings?.() }>⚙ OPEN AI SETTINGS</button>
  </div>

  <script>
    export default {
      openBackupImport() {
        this.$('[ref=\"backupImportInput\"]')?.click()
      },

      onBackupImportFile(e) {
        this.props.actions?.onBackupImportFile?.(e)
      },
    }
  </script>

  <style>
    .sys-section-account {
      .account-note {
        margin: 0 0 var(--space-lg);
        font-size: var(--type-xs, var(--space-sm));
        line-height: 1.5;
      }

      .account-note.guest {
        color: var(--danger);
      }

      .account-note.signed-in {
        color: var(--text-muted);
        letter-spacing: 0.05em;
      }

      .account-user-name {
        color: var(--gold);
      }
    }
  </style>
</sys-section-account>
